import EXIF from "exif-js"

export const IMAGE_MAX_LENGTH = 2048
export const DEFAULT_WATERMARK_TEXT = "限睿能辦理相關業務使用"
export const DEFAULT_WATERMARK_STYLE = "rgba(250,250,250,0.8)"

// input image file
export const getImageOrientation = (image) => {
  return new Promise((resolve) => {
    EXIF.getData(image, () => {
      const orientation = EXIF.getTag(image, "Orientation")
      resolve(orientation)
    })
  })
}

// input and export base64
export const resetImageOrientation = (sourceImage, orientation) => {
  return new Promise((resolve) => {
    const img = new Image()
    img.onload = function () {
      const width = img.width
      const height = img.height
      const canvas = document.createElement("canvas")
      const ctx = canvas.getContext("2d")

      // set proper canvas dimensions before transform & export
      if (4 < orientation && orientation < 9) {
        canvas.width = height
        canvas.height = width
      } else {
        canvas.width = width
        canvas.height = height
      }

      // transform context before drawing image
      switch (orientation) {
        case 1:
          ctx.transform(1, 0, 0, 1, 0, 0)
          break
        case 2:
          ctx.transform(-1, 0, 0, 1, width, 0)
          break
        case 3:
          ctx.transform(-1, 0, 0, -1, width, height)
          break
        case 4:
          ctx.transform(1, 0, 0, -1, 0, height)
          break
        case 5:
          ctx.transform(0, 1, 1, 0, 0, 0)
          break
        case 6:
          ctx.transform(0, 1, -1, 0, height, 0)
          break
        case 7:
          ctx.transform(0, -1, -1, 0, height, width)
          break
        case 8:
          ctx.transform(0, -1, 1, 0, 0, width)
          break
        default:
          ctx.transform(1, 0, 0, 1, 0, 0)
          break
      }

      ctx.drawImage(img, 0, 0)

      // export base64
      resolve(canvas.toDataURL("image/jpeg"))
    }

    img.src = sourceImage
  })
}

// input and export base64
export const resizeImage = (inputImage) => {
  return new Promise((resolve) => {
    const img = new Image()
    img.onload = function () {
      const width = img.width
      const height = img.height
      const canvas = document.createElement("canvas")
      const ctx = canvas.getContext("2d")
      const length = width > height ? width : height
      const ratio = length > IMAGE_MAX_LENGTH ? IMAGE_MAX_LENGTH / length : 1
      canvas.width = width * ratio
      canvas.height = height * ratio
      ctx.transform(ratio, 0, 0, ratio, 0, 0)
      ctx.drawImage(img, 0, 0)
      resolve(canvas.toDataURL("image/jpeg"))
    }
    img.src = inputImage
  })
}

// input and export base64
export const rotateImageClockwise90 = (inputImage) => {
  return new Promise((resolve) => {
    const img = new Image()
    img.onload = function () {
      const width = img.width
      const height = img.height
      const canvas = document.createElement("canvas")
      const ctx = canvas.getContext("2d")
      canvas.width = height
      canvas.height = width
      ctx.transform(0, 1, -1, 0, height, 0)
      ctx.drawImage(img, 0, 0)
      resolve(canvas.toDataURL("image/jpeg"))
    }
    img.src = inputImage
  })
}

export const addWatermark = ({
  inputImage,
  text = DEFAULT_WATERMARK_TEXT,
  style = DEFAULT_WATERMARK_STYLE,
  position = "top",
}) => {
  return new Promise((resolve) => {
    const img = new Image()
    img.onload = function () {
      const width = img.width
      const height = img.height
      const canvas = document.createElement("canvas")
      const ctx = canvas.getContext("2d")

      canvas.width = width
      canvas.height = height
      ctx.drawImage(img, 0, 0)
      ctx.font = `${height / 12}px noto-sans-light`
      ctx.fillStyle = style
      // position: right top or left
      if (position === "left") {
        ctx.rotate((90 * Math.PI) / 180)
        ctx.fillText(text, 20, -10)
      }
      ctx.fillText(text, width - ctx.measureText(text).width - 30, height / 12 + 30, width - 60)

      resolve(canvas.toDataURL("image/jpeg"))
    }
    img.src = inputImage
  })
}
